import { z } from "zod";

/** Convert a ZodError into a nested object for form field errors (e.g. errors.attendees[0].email) */
export function zodErrorToNested(error: z.ZodError): Record<string, unknown> {
  const nested: Record<string, unknown> = {};
  for (const issue of error.issues) {
    const path = issue.path;
    if (path.length === 0) continue;
    let current: Record<string, unknown> = nested;
    for (let i = 0; i < path.length - 1; i++) {
      const key = String(path[i]);
      if (!(key in current) || typeof current[key] !== "object" || current[key] === null) {
        current[key] = {};
      }
      current = current[key] as Record<string, unknown>;
    }
    const lastKey = String(path[path.length - 1]);
    current[lastKey] = issue.message;
  }
  return nested;
}

export const EventSchema = z.object({
  subject: z.string().min(1, "Required"),
  content: z.string().min(1, "Required"),
  startDateTime: z.date(),
  endDateTime: z.date(),
  location: z.string().optional(),
  attendees: z.array(
    z.object({
      emailAddress: z.string().email("Invalid email"),
    }),
  ).optional(),
});

export const GoogleEventSchema = z.object({
  summary: z.string().min(1, "Required"),
  location: z.string().min(1, "Required"),
  description: z.string().optional(),
  startDateTime: z.date(),
  endDateTime: z.date(),
  attendees: z.array(
    z.object({
      email: z.string().email("Invalid email"),
    }),
  ).optional(),
});

/**
 * Schema for the unified event EDIT dialog (provider-agnostic CalendarEvent).
 * Attendees are managed by AttendeeSelectWithModal outside react-hook-form, so
 * they are intentionally not part of this schema.
 */
export const EventEditSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().optional(),
  location: z.string().optional(),
  startDateTime: z.date({ message: "Start date/time is required" }),
  endDateTime: z.date({ message: "End date/time is required" }),
});

export type EventEditFormValues = z.infer<typeof EventEditSchema>;
